import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const SPANS = ["md:col-span-8", "md:col-span-4", "md:col-span-4", "md:col-span-4", "md:col-span-4"];

export default function Services({ content }) {
  const services = content.services || [];
  return (
    <section id="services" className="relative py-24 sm:py-32 bg-navy/40" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }} className="font-mono text-xs tracking-[0.25em] uppercase text-sky mb-4">
          What We Do
        </motion.p>
        <motion.h2 initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl">
          Interior &amp; exterior, done right.
        </motion.h2>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-5">
          {services.map((s, i) => (
            <motion.a key={s.title + i} href="#quote"
              initial={{ opacity: 0, y: 36 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 3) * 0.1 }}
              className={`group relative overflow-hidden rounded-3xl border border-white/10 min-h-[300px] col-span-1 ${SPANS[i % SPANS.length]} spotlight-card`}
              data-testid={`service-card-${i}`}>
              {s.image && (
                <img src={s.image} alt={s.title} loading="lazy"
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/60 to-ink/10" />
              <div className="relative z-[2] h-full flex flex-col justify-end p-8">
                <span className="font-mono text-[10px] tracking-[0.3em] text-sky/90 mb-2">0{i + 1}</span>
                <div className="flex items-end justify-between gap-4">
                  <div>
                    <h3 className="font-display font-bold text-xl sm:text-2xl tracking-tight">{s.title}</h3>
                    <p className="mt-2 text-sm text-slate-300/90 leading-relaxed max-w-md">{s.desc}</p>
                  </div>
                  <span className="shrink-0 rounded-full border border-white/20 p-3 text-slate-300 group-hover:bg-royal group-hover:border-royal group-hover:text-white transition-colors duration-300">
                    <ArrowUpRight className="h-4 w-4" />
                  </span>
                </div>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
